import { create } from 'zustand'
import { STATUS_LIST } from 'constants/docUploadConstant'

const { PENDING } = STATUS_LIST

export const useDocListStore = create((set, get) => ({
    dealerName: '',
    docs: [],
    setDealerName: (name) => set({ dealerName: name }),
    addDoc: (doc) => {
        set({
            docs: [...get().docs, doc]
        })
    },
    getDoc: (id) => {
        return get().docs.find((doc) => doc.id === id)
    },
    deleteDoc: (documentId) => {
        const docIndex = get().docs.findIndex((doc) => doc.documentId === documentId)

        if (docIndex != -1) {
            get().docs[docIndex] = {
                ...get().docs[docIndex],
                status: PENDING,
                mimeType: '',
                base64Data: '',
                documentId: ''
            }
            get().setDocs(get().docs)
        }
    },
    updateDoc: (id, data) => {
        const docIndex = get().docs.findIndex((doc) => doc.id === id)

        if (docIndex != -1) {
            get().docs[docIndex] = {
                ...get().docs[docIndex],
                ...data
            }
            get().setDocs(get().docs)
        }
    },
    setDocs: (data) => set({ docs: data })
}))
